import { getBasePath } from '../../utils/config';
import { safeJsonParse, buildUrl } from 'api/utils/fetchHelpers';
import { IGetTenantInfoAPIResponse } from 'api/endpoints/brandFeed/brandFeed.response.interface';

export const getTenantInfoAPI = async ({
  tenantId,
  countryId,
  token,
}: {
  tenantId: string;
  countryId: string;
  token: string;
}): Promise<IGetTenantInfoAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/brand_profile/get_tenant_profile`, {
      tenant_id: tenantId,
      country_id: countryId,
    }),
    params
  );
  return await safeJsonParse(response);
};
